module.exports = __webpack_public_path__ + "img/Addfolder.f278432a.png";